// extracted by mini-css-extract-plugin
export default {"marker":"Marker_marker__ZIFVr"};